import { Component } from '@angular/core';

import { App, NavController, AlertController, ActionSheetController, LoadingController, ToastController } from 'ionic-angular';

import { User } from '../../providers/user';


/**
 * Forgot Page
 * 
 * @export
 * @class AccountEmailPage
 */
@Component({
  selector: 'account-email',
  templateUrl: 'account-email.html'
})
export class AccountEmailPage {
  login: { email?: string } = {
    email: this.user.fb.auth().currentUser.email
  };
  submitted = false;
  /**
   * Creates an instance of AccountEmailPage.
   * 
   * @param {NavController} nav
   * @param {UserData} userData
   * @param {AlertController} alert
   * @param {ActionSheetController} actionSheet
   * @param {LoadingController} loading
   */
  constructor(
    public app: App,
    public user: User,
    public loading: LoadingController,
    public toast: ToastController,
    public nav: NavController,
    public alert: AlertController,
    public actionSheet: ActionSheetController
  ) {

  }
  // ionViewDidEnter() { }
  /**
   * 
   * 
   * @private
   * @param {any} form
   */
  public onModify(form) {
    let loader = this.loading.create({
      content: 'Please wait..',
      duration: 10000
    });
    this.submitted = true;
    if (form.valid) {
      loader.present();
      this.user.fb.auth().currentUser.updateEmail(this.login.email).then(() => {
        // setTimeout(() => {
        loader.dismiss().then(() => {
          // setTimeout(() => {
          this.showAlert('Sucess', 'Your email has been changed.');
          // });
        });
        // });
      }, (error) => {
        //  setTimeout(() => {
        loader.dismiss().then(() => {
          // setTimeout(() => {
          this.loginError(error);
          // });
        });
        // });
      });
    }
  }

  /**
   * Show Alert
   * 
   * @param {any} title
   * @param {any} subtitle
   */
  public showAlert(title, subtitle) {
    this.user.showAlert(title, subtitle);
  }
  /**
   * 
   * 
   * @param {any} error
   */
  public loginError(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    this.showAlert(handler.title, handler.message);
  }
}


// WEBPACK FOOTER //
// ./src/pages/account-email/account-email.ts